import window from 'global/window';
function computedStyle(el, prop) {
    if (!el || !prop) {
        return '';
    }
    if (typeof window.getComputedStyle === 'function') {
        var cs = window.getComputedStyle(el);
        return cs ? cs[prop] : '';
    }
    return '';
}
export default computedStyle;